import { FormControl, InputLabel, Select, MenuItem, Checkbox, ListItemText, Button, TextField } from '@mui/material'
import React, { useState } from 'react'

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

import ErrorAlert from "../../../../toolkit/ErrorAlert";
import ReportExpiringDocument from './ReportExpiringDocument';
import ReportSubsectionReport from './ReportSubsectionReport';
import ReportInvitationSent from './ReportInvitationSent';
import ReportInjuryStatistics from './ReportInjuryStatistics';
import ReportInsuranceInformation from './ReportInsuranceInformation';
import ReportStatisticsHistory from './ReportStatisticsHistory';
import ReportFeesPaid from './ReportFeesPaid';
import ReportFinancialAnalytics from './ReportFinancialAnalytics';
import ReportVendorConTractInfo from './ReportVendorConTractInfo';
import ReportTrainingGuide from './ReportTrainingGuide';
import ReportContractorEvalution from './ReportContractorEvalution';
import ReportMulticlientPrequilification from './ReportMulticlientPrequilification';
import ReportExpiredDocument from './ReportExpiredDocument';
import ReportOnsiteOffsiteClient from './ReportOnsiteOffsiteClient';
import ReportOnsiteOffsiteVendor from './ReportOnsiteOffsiteVendor';
import ReportSineproCheckInCheckout from './ReportSineproCheckInCheckout';
import ReportVendorTrainingName from './ReportVendorTrainingName';
import ReportVistors from './ReportVistors';
import ReportLuckStone from './ReportLuckStone';
import OrmatAlt from './Ormat_ALT_PQ';
import GPCStandardReport from './GPC_StandardReport';
import ClientUploads from './ClientUploadsReport';


export default function ReportForm({ close, name, type, url }) {

  return (
    <>
      <div >
        {type == 1 ? (
          <>
            <ReportExpiringDocument close={close} name={name} postUrl={url} />
          </>
        ) : type == 6 ? (
          <>
            <ReportVendorTrainingName close={close} name={name} postUrl={url} />
          </>
        ) : type == 7 ? (
          <>
            <ReportSubsectionReport close={close} name={name} postUrl={url} />
          </>
        ) : type == 11 ? (
          <>
            <ReportInvitationSent close={close} name={name} postUrl={url} />
          </>
        ) : type == 12 ? (
          <>
            <ReportContractorEvalution close={close} name={name} postUrl={url} />
          </>
        ) : type == 14 ? (
          <>
            <ReportInjuryStatistics close={close} name={name} postUrl={url} />
          </>
        ) : type == 15 ? (
          <>
            <ReportInsuranceInformation close={close} name={name} postUrl={url} />
          </>
        ) : type == 16 ? (
          <>
            <ReportStatisticsHistory close={close} name={name} postUrl={url} />
          </>
        ) : type == 17 ? (
          <>
            <ReportFeesPaid close={close} name={name} postUrl={url} />
          </>
        ) : type == 19 ? (
          <>
            <ReportFinancialAnalytics close={close} name={name} postUrl={url} />
          </>
        ) : type == 20 ? (
          <>
            <ReportVendorConTractInfo close={close} name={name} postUrl={url} />
          </>
        ) : type == 21 ? (
          <>
            <ReportMulticlientPrequilification close={close} name={name} postUrl={url} />
          </>
        ) : type == 24 ? (
          <>
            <ReportTrainingGuide close={close} name={name} postUrl={url} />
          </>
        ) : type == 2 ? (
          <>
            <ReportExpiredDocument close={close} name={name} postUrl={url} />
          </>
        ) : type == 10 ? (
          <>
            <ReportOnsiteOffsiteClient close={close} name={name} postUrl={url} />
          </>
        ) : type == 8 ? (
          <>
            <ReportOnsiteOffsiteVendor close={close} name={name} postUrl={url} />
          </>
        ) : type == 18 ? (
          <>
            <ReportSineproCheckInCheckout close={close} name={name} postUrl={url} />
          </>
        ) : type == 9 ? (
          <>
            <ReportVistors close={close} name={name} postUrl={url} />
          </>
        ) : type == 25 ? (
          <>
            <ReportLuckStone close={close} name={name} postUrl={url} />
          </>
        ) : type == 26 ? (
          <>
            <OrmatAlt close={close} name={name} postUrl={url} />
          </>
        ) : type == 27 ? (
          <>
            <GPCStandardReport close={close} name={name} postUrl={url} />
          </>
        ) : type == 28 ? (
          <>
            <ClientUploads close={close} name={name} postUrl={url} />
          </>
        ) : (
          <ErrorAlert severity="warning" message="Nothing to show!" />
        )}
      </div>

    </>
  );
}
